<script>
    import REST from './RESTClass.js';

    let settings;
    const API = new REST();

    API.getSettings()
        .then(data => settings = data);
</script>

<main>
    {#if settings}
        <video autoplay muted loop>
            <source src={settings.background} type="video/mp4">
        </video>
    {/if}
    <section class="content">
        <slot></slot>
    </section>
</main>

<style type="text/scss">
    main {
        padding: 2rem 0;

        video {
            position: fixed;
            right: 0;
            bottom: 0;
            min-width: 100%;
            min-height: 100%;
            height: auto;
            opacity: .15;
            z-index: 0;
        }

        .content {
            position: relative;
        }
    }
</style>